import React from "react";
import LeaveList from "../../components/features/leaves/LeaveList";

const LeavesPage = () => {
  return <LeaveList />;
};

export default LeavesPage;
